// utils/urlHelpers.ts

export function extractUsernameFromURL(url: string): string {
  try {
    // Add protocol if missing
    const urlString = url.startsWith("http") ? url : `https://${url}`;
    const urlObj = new URL(urlString);

    // Remove trailing slashes
    const pathname = urlObj.pathname.replace(/\/+$/, "");

    // Split path into segments
    const segments = pathname.split("/").filter(Boolean);

    // Handle different platforms
    if (urlObj.hostname.includes("github.com")) {
      return segments[0] || "";
    }

    if (urlObj.hostname.includes("linkedin.com")) {
      // Handle both /in/username and /company/company-name formats
      if (segments[0] === "in" || segments[0] === "company") {
        return segments[1] || "";
      }
      return segments[0] || "";
    }

    if (urlObj.hostname.includes("behance.net")) {
      return segments[0] || "";
    }

    if (urlObj.hostname.includes("dribbble.com")) {
      return segments[0] || "";
    }

    // For any other URL, return the first path segment
    return segments[0] || "";
  } catch (error) {
    // If URL is invalid, return the original string
    return url;
  }
}
